import React from 'react';
import { GeniePadElementsSettingItem } from '../../api/pushGenie';
import { PAD_CONFIG_FOLLOW_UP_ADVICES_ID } from '../../constants';

interface Props {
    padElementsConfig: GeniePadElementsSettingItem[];
    remainingPxElements: string[];
    renderPadElements: (item: GeniePadElementsSettingItem) => React.ReactNode;
    renderOtherElements: (item: string) => React.ReactNode;
}

const ViewSummary: React.FC<Props> = (props) => {
    return (
        <div className="flex-1 p-16 space-y-8 overflow-auto h-full">
            {props.padElementsConfig
                ?.filter((t) => t.isShown && t.id !== PAD_CONFIG_FOLLOW_UP_ADVICES_ID)
                ?.map((item) => props.renderPadElements(item))}
            {/* TODO we might not need remainingPxElements */}
            {props.remainingPxElements.map((item) => props.renderOtherElements(item))}
        </div>
    );
};

export default ViewSummary;
